<template>
  <v-tooltip v-if="qtyLocked && size > 0" left max-width="200">
    <template v-slot:activator="{ on, attrs }">
      <div
        class="pack-size"
        v-bind="attrs"
        v-on="on"
        :aria-label="`Pack ${size} pz`"
        role="button"
      >
        <span>pack {{ size }} pz</span>
      </div>
    </template>
    <span v-text="$t('product.packSizeTooltip', { count: this.size })"> </span>
  </v-tooltip>
</template>
<script>
import get from "lodash/get";
export default {
  name: "ProductAcqLimit",
  props: ["product"],
  computed: {
    size() {
      let packageSize = get(this.product, "productInfos.QTY_MULT", 0);

      return packageSize;
    },
    qtyLocked() {
      return get(this.product, "productInfos.QTY_LOCKED") == "true";
    }
  }
};
</script>
<style lang="scss">
.pack-size {
  max-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  span {
    min-width: 100%;
    text-transform: uppercase;
    padding: 5px;
    color: var(--v-default-base);
    line-height: 1;
    background-color: var(--v-primary-lighten2);
    font-size: 10px;
    font-weight: bold;
    display: flex;
    text-align: center;
    border-radius: $border-radius-root;
    justify-content: center;
    align-items: center;
  }
}
</style>
